@if (show) {
  <div class="d-flex flex-column gap-0 text-wrap">
    <div>{{ productType }}</div>
    <strong>{{ productKey }}</strong>
    <div>{{ productDescription }}</div>
  </div>
}
